import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { FilteredPageQuery } from 'shared';

export const TRANSLATION_SERVICE_IMPL = new InjectionToken<ITranslationService>(
    'translationServiceImpl'
);

export interface ITranslationService {
    getCategories(value: any): Observable<any>;
    publish(targets: any[]): Observable<any>;
    getTargetList(): Observable<any>;
    getTable(appid: string): Observable<any>;
    upload_i18(formData: FormData): void;
    saveTranslation(translation: any): Observable<any>;
    deleteTranslation(translation: any): Observable<any>;
}
